module.exports = __webpack_public_path__ + "static/AlbusA-97f5c1d3150745f3847208b376be1e45.gif";